<template>
  <div class="table_margin_0">
    <div class="title_h1">工事・作業状況</div>
    <vab-query-form
      ref="queryForm"
      class="dpform DPR01G01"
      :model="queryForm"
      :rules="rules"
      size="mini"
      label-width="98px"
      @search="fetchData"
    >
      <vab-row :gutter="20">
        <vab-col :lg="8" :xl="8" :md="12">
          <vab-select
            ref="docSubmitStatusRef"
            label="報告書提出状況"
            prop="reportSubmitStatusList"
            filter="docSubmitStatus"
            class="label_height"
            collapse-tags
            clearable
            multiple
          />
        </vab-col>
        <vab-col :lg="8" :xl="8" :md="12">
          <vab-select
            label="工事·作業完了状況"
            prop="constructionCompletionStatusList"
            filter="finishFlg"
            class="label_height"
            collapse-tags
            clearable
            multiple
          />
        </vab-col>
        <vab-col :lg="8" :xl="8" :md="12">
          <vab-select
            label="案件分類"
            prop="businessFormList"
            filter="consignmentWorkClass"
            collapse-tags
            clearable
            multiple
          />
        </vab-col>
        <vab-col :lg="8" :xl="8" :md="12">
          <vab-input
            v-input.num_alp
            label="受注キー"
            prop="acceptOrderKey"
            maxlength="13"
          ></vab-input>
        </vab-col>
        <vab-col :lg="8" :xl="8" :md="12">
          <vab-input label="発注No" prop="acceptOrderNo"></vab-input>
        </vab-col>

        <vab-col :lg="8" :xl="8" :md="12">
          <!-- <CommonSelect
            label="建物"
            :componentcd.sync="queryForm.purchaseOrderBase.buildingCd"
            cname="building"
          /> -->
          <vab-input label="建物" prop="blgsnmkj"></vab-input>
          <!-- <Building
            :blgscd.sync="queryForm.buildingCdList"
            :bldgcd.sync="queryForm.sectionCdList"
            :span1="6"
            :span2="6"
            :span3="12"
          /> -->
        </vab-col>
        <vab-col :lg="8" :xl="8" :md="12">
          <vab-input label="商品" prop="itmnm" show-after="半角ｶﾅ"></vab-input>
          <!-- <Mitmdtlp
            :componentcd.sync="queryForm.itemDetailCdList"
            :span1="6"
            :span2="18"
          /> -->
        </vab-col>
        <vab-col :lg="8" :xl="8" :md="12">
          <vab-input
            label="商品明細"
            prop="itmdtlnm"
            show-after="半角ｶﾅ"
          ></vab-input>
          <!-- <Mitmdtlp
            :componentcd.sync="queryForm.itemDetailCdList"
            :span1="6"
            :span2="18"
          /> -->
        </vab-col>
        <vab-collapse :title="'詳細検索を表示'">
          <div class="flex_start">
            <vab-col :lg="8" :xl="8" :md="12">
              <vab-input label="進行部門" prop="progressDepName"></vab-input>
            </vab-col>
            <vab-col :lg="8" :xl="8" :md="12">
              <vab-input
                label="進行担当者"
                prop="progressPersonName"
                show-after="半角ｶﾅ"
              ></vab-input>
            </vab-col>
            <vab-col :lg="8" :xl="8" :md="12">
              <vab-input label="発注件名" prop="purchaseOrderName"></vab-input>
            </vab-col>
          </div>
          <vab-col :lg="8" :xl="8" :md="12">
            <el-form-item class="big_label_110" label="納品予定年月">
              <el-row type="flex">
                <el-col :span="11">
                  <vab-date-picker
                    type="month"
                    class="date_box no_margin"
                    :label-show="false"
                    value-format="yyyy/MM/01"
                    format="yyyy/MM"
                    prop="planDeliveryYmStartDateTime"
                    end-date-prop="planDeliveryYmEndDateTime"
                  />
                </el-col>
                <el-col :span="2" class="line flex_center flex_center_align">
                  ～
                </el-col>
                <el-col :span="11">
                  <vab-date-picker
                    type="month"
                    class="date_box no_margin"
                    :label-show="false"
                    value-format="yyyy/MM"
                    format="yyyy/MM"
                    prop="planDeliveryYmEndDateTime"
                    start-date-prop="planDeliveryYmStartDateTime"
                  />
                </el-col>
              </el-row>
            </el-form-item>
          </vab-col>
        </vab-collapse>
      </vab-row>
    </vab-query-form>
    <el-row>
      <el-col>
        <vab-table
          ref="table"
          api-url="/api/workImplementStatus/partner/pager"
          :init-params="{
            ...queryForm,
            sidx: 'purchaseOrderBaseIdModel.acceptOrderKey,implementStatusId',
            sort: 'desc,desc',
          }"
          :columns="columns"
          :query-params="{
            ...queryForm,
            sidx: 'purchaseOrderBaseIdModel.acceptOrderKey,implementStatusId',
            sort: 'desc,desc',
          }"
          primary-key="implementStatusId"
          :enable-init="reloadPage"
          :span="20"
        />
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import reload from '@/utils/reload'

  export default {
    name: 'PWS03G01',
    extends: reload,
    data() {
      return {
        rules: {},
        queryForm: {
          reportSubmitStatusList: [],
        },
        columns: [
          {
            label: '建物',
            'min-width': 140,
            sortable: true,
            prop: 'purchaseOrderBaseIdModel.buildingCdMbuildgpModel.blgsnmkj',
            disableCheck: true,
          },
          {
            sortable: true,
            label: '受注キー',
            'min-width': 120,
            prop: 'purchaseOrderBaseIdModel.acceptOrderKey',
            disableCheck: true,
          },
          {
            label: '発注NO',
            'min-width': 100,
            sortable: true,
            prop: 'purchaseOrderBaseIdModel.acceptOrderNo',
          },
          {
            label: '案件分類',
            prop: 'demandBaseIdModel.businessForm',
            sortable: true,
            'min-width': 120,
            formatter: (row, column, cellValue) => {
              return this.getEnumText(
                cellValue,
                this.$divisions.consignmentWorkClassEnum
              )
            },
          },
          {
            label: '商品',
            sortable: true,
            'min-width': 80,
            prop: 'demandBaseIdModel.itemCdModel.itmnm',
          },

          {
            label: '商品明細',
            'min-width': 100,
            prop: 'purchaseOrderBaseIdModel.itemCdModel.itmdtlnm',
            sortable: true,
          },
          {
            label: '発注件名',
            'min-width': 180,
            sortable: true,
            prop: 'purchaseOrderBaseIdModel.purchaseOrderName',
          },
          {
            label: '進行部門',
            sortable: true,
            'min-width': 120,
            prop: 'purchaseOrderBaseIdModel.purchaseOrderDepCdModel.orgkj',
          },
          {
            label: '進行担当者',
            sortable: true,
            'min-width': 120,
            prop: 'purchaseOrderBaseIdModel.approvalApplyPersonCdModel.empnmkj',
          },
          {
            sortable: true,
            label: '納品月',
            'min-width': 120,
            prop: 'demandBaseIdModel.contractEndDate',
            formatter: (row, column, cellValue) => {
              return this.getFomateMonth(cellValue)
            },
          },
          {
            label: '報告書提出予定月',
            sortable: true,
            'min-width': 180,
            prop: 'reportSubmitYearMonth',
            formatter: (row, column, cellValue) => {
              return this.getFomateMonth(cellValue)
            },
          },
          {
            label: '報告書提出状況',
            sortable: true,
            'min-width': 140,
            prop: 'reportSubmitStatus',
            formatter: (row, column, cellValue) => {
              return this.getEnumText(
                cellValue,
                this.$divisions.docSubmitStatusEnum
              )
            },
          },
          {
            label: '工事·作業開始日',
            sortable: true,
            'min-width': 140,
            prop: 'planStartDate',
          },
          {
            label: '工事・作業終了日',
            sortable: true,
            prop: 'planEndDate',
            'min-width': 160,
          },
          {
            label: '工事・作業完了日',
            sortable: true,
            prop: 'workFinishDate',
            'min-width': 160,
          },
          {
            label: '工事·作業完了状況',
            sortable: true,
            prop: 'constructionCompletionStatus',
            'min-width': 160,
            formatter: (row, column, cellValue) => {
              return this.getEnumText(cellValue, this.$divisions.finishFlgEnum)
            },
          },
          {
            // 按钮
            type: 'actions',
            label: '操作',
            fixed: 'right',
            'min-width': '120',
            disableCheck: true,
            actions: [
              {
                name: '報告書提出',
                type: 'text',
                click: (row) => {
                  this.$routerPush({
                    name: 'PWS03G02',
                    query: {
                      implementStatusId: row.implementStatusId,
                    },
                  })
                },
              },
              {
                name: '資料連携',
                type: 'text',
                show: (row) => {
                  return this.checkEnumFlag(row.fileConfirmFlg)
                },
                click: (row) => {
                  this.$routerPush({
                    name: 'DWS03G04',
                    query: {
                      implementStatusId: row.implementStatusId,
                    },
                  })
                },
              },
            ],
          },
        ],
      }
    },
    created() {
      this.$baseEventBus.$on('ComponentReset', () => {
        this.queryForm.reportSubmitStatusList = []
      })
    },
    mounted() {
      this.getDocSubmitStatusList()
    },
    methods: {
      // 検索ボタン
      fetchData() {
        if (
          this.queryForm['planDeliveryYmEndDateTime'] &&
          this.queryForm['planDeliveryYmEndDateTime'].length == 7
        ) {
          this.queryForm.planDeliveryYmEndDateTime =
            this.queryForm['planDeliveryYmEndDateTime'] +
            '/' +
            this.$dayjs(
              this.queryForm['planDeliveryYmEndDateTime']
            ).daysInMonth()
        }
        this.$refs.table.fetchData()
      },
    },
  }
</script>

<style lang="scss" scoped>
  .item_box {
    padding-top: 10px;
    padding-right: 8px;
    .sub_title {
      font-size: 12px;
      font-weight: 400;
      line-height: 28px;
      color: #848484;
    }
    .sub_buttom {
      display: inline-block;
      padding: 0 10px;
      padding-right: 30px;
      font-size: 12px;
      font-weight: 400;
      line-height: 28px;
      color: #003350;
      background: #f7f7f7;
      background: url('~@/assets/images/close.png') right 8px center no-repeat,
        #f7f7f7;
      border: 1px solid #efefef;
      border-radius: 4px;
    }
  }
</style>
